import React, { Component } from 'react';
import App_data from '../../../config/App_data';
import FD from '../../../RestAPI/fetchData';
import FrmSubscriptionCheck from '../../../RestAPI/FrmSubscription';
import PartnerFRMSubscriptionCheck from '../../../RestAPI/PartnerSubscription/FrmSubscription';
import language from '../../../../assets/languages/language';
import ModalComponent from '../../../Common/Modal';
import AlertMessage from '../../../config/alertMessage';
import Loader from '../../../../common/loader';
import CBTMockExamsInsructions from '../../../Common/CBTInstructions';
import { hasMockAccessFromBackend } from '../../../../utils/CommonUtils';
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
} from 'reactstrap';
/* eslint-disable*/

class CBTMockExams extends Component {
  constructor(props) {
    super(props);
    const messageTitle_frm = `<i class="icon-info icons font-2xl d-block "></i>`;
    this.state = {
      alert_status: false,
      pdfAlert: false,
      MessageTitle: messageTitle_frm,
      MessageContent: AlertMessage.messageContent_frm,
      mockList: [],
      token: '',
      idname: '',
      ValidToken: false,
      subscriptionstatus: '',
      showFreePremium: true,
      selectedmenu: 'frm',
      cfaUnlimitedPackage: '',
      cfaUnlimitedActiveExam: '',
      type: 'question',
      PDFContentMessage: language.LC().PDFContentMessage,
      isLoading: true,
      mockData: '',
      userStatsData: '',
      pdfLoadingQ: false,
      pdfLoadingQA: false,
      pdfMessage: '',
      pdfMessageOpen: false,
      dropdownOpen: false,
      dropdownOpenIndex: '',
    };
    this.toggleAlert = this.toggleAlert.bind(this);
    this.togglePdfMessage = this.togglePdfMessage.bind(this);
  }

  togglePdfMessage() {
    this.setState({ pdfMessageOpen: !this.state.pdfMessageOpen });
  }

  toggleAlert() {
    this.setState({
      alert_status: !this.state.alert_status,
    });
  }

  //it is use to redirect page
  static contextTypes = {
    router: React.PropTypes.object,
  };

  //Function to redirect page to viewquestions page
  getQuestions = (mock) => {
    this.setState({
      showInstructionModal: false,
    });
    const user_data = { token: this.state.token, idname: this.state.idname };
    FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then(
      (resp) => {
        if (resp.profileInfo.role === 'partner') {
          if (
            resp.profileInfo.exam_selected === '' &&
            resp.profileInfo.exam_package === ''
          ) {
            this.toggleAlert();
          } else {
            const data_arr = resp.profileInfo.exam_selected
              ? JSON.parse(resp.profileInfo.exam_selected)
              : null;
            const dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            FD.callAPI(
              App_data.backend_api + '/checkout_v1/getExamsbyUser',
              dataset
            ).then(async (resp_exam) => {
              if (resp_exam.success) {
                const exam_data = resp_exam.examData;
                const subscriptionStatus = await PartnerFRMSubscriptionCheck.checkFrm(
                  mock.level,
                  exam_data
                );
                const hasMockAccess = hasMockAccessFromBackend(
                  resp_exam.hasMockSubscription,
                  mock.level
                );
                if (subscriptionStatus || hasMockAccess) {
                  this._runCode('paid', mock);
                } else {
                  this.toggleAlert();
                }
              } else {
                //console.log('fail');
              }
            });
          }
        } else {
          if (resp.profileInfo.exam_selected === '') {
            this.toggleAlert();
          } else {
            const data_arr = JSON.parse(resp.profileInfo.exam_selected);
            const dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            FD.callAPI(
              App_data.backend_api + '/checkout_v1/getExamsbyUser',
              dataset
            ).then((resp_exam) => {
              if (resp_exam.success) {
                const exam_data = resp_exam.examData;
                const subscriptionStatus = FrmSubscriptionCheck.checkFrm(
                  mock.level,
                  exam_data
                );
                if (subscriptionStatus) {
                  this._runCode('paid', mock);
                } else {
                  this.toggleAlert();
                }
              } else {
                //console.log('fail');
              }
            });
          }
        }
      }
    );
  };

  _runCode = (subscriptionstatus, mock) => {
    if (subscriptionstatus === 'paid') {
      this.context.router.push({
        pathname: `/introduction/${mock.id}/1/${mock.timer}`,
      });
    }
  };
  //On Page Load,init this method
  async componentDidMount() {
    window.scrollTo(0, 0);
    const storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    const data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    // get level 1 mocks
    FD.callAPI(
      App_data.backend_api + '/frmCBTMockExams/getFRMMockExams',
      data
    ).then((resp) => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          mockList: resp.mock,
          isLoading: false,
          userStatsData: resp.userstats,
        });
      } else {
        this.setState({ ValidToken: false, isLoading: false });
      }
      return resp;
    });
    // get level 2 mocks
    FD.callAPI(
      App_data.backend_api + '/frmCBTMockExams/getFRM2MockExams',
      data
    ).then((resp) => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          mockList2: resp.mock,
          isLoading: false,
          userStatsData: resp.userstats,
        });
      } else {
        this.setState({ ValidToken: false, isLoading: false });
      }
      return resp;
    });
  }

  goPremium = () => {
    this.context.router.push({
      pathname: '/Subscribe/',
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: this.state.selectedmenu,
      },
    });
  };

  startExam = (mock) => {
    this.setState({
      showInstructionModal: true,
      mockData: mock,
    });
  };

  viewAttemptedExams = (mock) => {
    this.context.router.push({
      pathname: `/frm/viewattemptedmock/${mock.id}/${mock.timer}/${mock.level}`,
    });
  };

  openQPDF = (id) => {
    const data = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: id,
    };
    FD.callAPI(
      App_data.backend_api + '/frmCBTMockExams/MockQPdfDownload',
      data
    ).then((resp) => {
      if (resp.success) {
        this.setState({
          pdfLoadingQ: false,
        });
        const myWindow = window.open(resp.DownloadLink);
        myWindow.focus();
      } else {
        // No PDF generated yet — stop the spinner and tell the user instead of a silent click.
        this.setState({
          pdfLoadingQ: false,
          pdfMessage: resp.message || 'The PDF for this mock is not available yet.',
          pdfMessageOpen: true,
        });
      }
      return resp;
    });
  };

  openQAPDF = (id) => {
    const data = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: id,
    };
    FD.callAPI(
      App_data.backend_api + '/frmCBTMockExams/MockQAPdfDownload',
      data
    ).then((resp) => {
      if (resp.success) {
        this.setState({
          pdfLoadingQA: false,
        });
        const myWindow = window.open(resp.DownloadLink);
        myWindow.focus();
      } else {
        // No PDF generated yet — stop the spinner and tell the user instead of a silent click.
        this.setState({
          pdfLoadingQA: false,
          pdfMessage: resp.message || 'The PDF for this mock is not available yet.',
          pdfMessageOpen: true,
        });
      }
      return resp;
    });
  };

  checkSubscription = (mock, type) => {
    const user_data = { token: this.state.token, idname: this.state.idname };
    FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then(
      (resp) => {
        if (resp.profileInfo.role === 'partner') {
          if (
            resp.profileInfo.exam_selected === '' &&
            resp.profileInfo.exam_package === ''
          ) {
            this.toggleAlert();
          } else {
            const data_arr = resp.profileInfo.exam_selected
              ? JSON.parse(resp.profileInfo.exam_selected)
              : null;
            const dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            FD.callAPI(
              App_data.backend_api + '/checkout_v1/getExamsbyUser',
              dataset
            ).then(async (resp_exam) => {
              if (resp_exam.success) {
                const exam_data = resp_exam.examData;
                const subscriptionStatus = await PartnerFRMSubscriptionCheck.checkFrm(
                  mock.level,
                  exam_data
                );
                const hasMockAccess = hasMockAccessFromBackend(
                  resp_exam.hasMockSubscription,
                  mock.level
                );
                if (subscriptionStatus || hasMockAccess) {
                  if (type === 'Q') {
                    this.openQPDF(mock.id);
                  } else {
                    this.openQAPDF(mock.id);
                  }
                } else {
                  this.toggleAlert();
                }
              } else {
                //console.log('fail');
              }
            });
          }
        } else {
          if (resp.profileInfo.exam_selected === '') {
            this.toggleAlert();
          } else {
            const data_arr = JSON.parse(resp.profileInfo.exam_selected);
            const dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            FD.callAPI(
              App_data.backend_api + '/checkout_v1/getExamsbyUser',
              dataset
            ).then((resp_exam) => {
              if (resp_exam.success) {
                const exam_data = resp_exam.examData;
                const subscriptionStatus = FrmSubscriptionCheck.checkFrm(
                  mock.level,
                  exam_data
                );
                if (subscriptionStatus) {
                  if (type === 'Q') {
                    this.openQPDF(mock.id);
                  } else {
                    this.openQAPDF(mock.id);
                  }
                } else {
                  this.toggleAlert();
                }
              } else {
                //console.log('fail');
              }
            });
          }
        }
      }
    );
  };

  toggle = (index) => {
    this.setState({
      dropdownOpenIndex: index,
      dropdownOpen: !this.state.dropdownOpen,
    });
  };

  render() {
    const {
      mockList,
      isLoading,
      showInstructionModal,
      mockData,
      mockList2,
      dropdownOpen,
      dropdownOpenIndex,
    } = this.state;

    return (
      <div>
        <div className='animated fadeIn'>
          {/* frm lEVEL 1 */}{' '}
          <div className='row'>
            <div className='col-md-8 margin_bottom_20'>
              <h1 className='section_head'>{language.LC().FRM1_MOCK_LIST}</h1>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12'>
              <div className='card'>
                <div className='table_responsive_wrapper'>
                  <div className='table-responsive min-max-510'>
                    <table className='table_white_bg table'>
                      <thead>
                        <tr className='border_top_0'>
                          <th width='90'>#</th>
                          <th className='mw-190'>{language.LC().MOCKEXAM}</th>
                          <th className='w-280 text-center'>
                            {language.LC().ACTION}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading ? (
                          <tr>
                            <Loader />
                          </tr>
                        ) : mockList.length ? (
                          mockList.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td>{item.id}.</td>
                                <td>{item.mock_exam} </td>
                                <td>
                                  <span
                                    className='btn btn-primary pointer_class small-btn tooltip_wrap margin_right_20'
                                    onClick={() =>
                                      this.viewAttemptedExams(item)
                                    }
                                  >
                                    {language.LC().START}
                                  </span>
                                  <span className='privetinfo-dropdown'>
                                    <ButtonDropdown
                                      className={
                                        index + 1 === mockList.length
                                          ? 'dropup'
                                          : ''
                                      }
                                      isOpen={
                                        dropdownOpenIndex === item.id
                                          ? dropdownOpen
                                          : false
                                      }
                                      toggle={() => this.toggle(item.id)}
                                    >
                                      <DropdownToggle
                                        className='btn btn-primary pointer_class small-btn tooltip_wrap margin_right_20'
                                        caret
                                      >
                                        {language.LC().PRINT}
                                      </DropdownToggle>
                                      <DropdownMenu right>
                                        <DropdownItem
                                          value='public'
                                          onClick={() => {
                                            this.checkSubscription(item, 'Q');
                                          }}
                                        >
                                          <i
                                            className='fa fa-print color-black'
                                            aria-hidden='true'
                                          />
                                          {language.LC().PRINT_Q_MOCK}
                                        </DropdownItem>
                                        <DropdownItem
                                          value='private'
                                          onClick={() => {
                                            this.checkSubscription(item, 'QA');
                                          }}
                                        >
                                          <i
                                            className='fa fa-print color-black'
                                            aria-hidden='true'
                                          />
                                          {language.LC().PRINT_QA_MOCK}
                                        </DropdownItem>
                                      </DropdownMenu>
                                    </ButtonDropdown>
                                  </span>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td
                              colSpan={'4'}
                              className={'text-center py-4 px-2'}
                            >
                              <div className='no-qus-found no-mock-exam'>
                                <img
                                  width='80px'
                                  src={
                                    App_data.frontend_url +
                                    '/img/questions/problem.png'
                                  }
                                />
                                <h3>{language.LC().No_Mock_Exams}</h3>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* frm lEVEL 2 */}
          <div className='row'>
            <div className='col-md-8 margin_bottom_20'>
              <h1 className='section_head'>{language.LC().FRM2_MOCK_LIST}</h1>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12'>
              <div className='card'>
                <div className='table_responsive_wrapper'>
                  <div className='table-responsive min-max-510'>
                    <table className='table_white_bg table'>
                      <thead>
                        <tr className='border_top_0'>
                          <th width='90'>#</th>
                          <th className='mw-190'>{language.LC().MOCKEXAM}</th>
                          <th className='w-280 text-center'>
                            {language.LC().ACTION}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading ? (
                          <tr>
                            <Loader />
                          </tr>
                        ) : mockList2 && mockList2.length ? (
                          mockList2.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td>{item.id}.</td>
                                <td>{item.mock_exam} </td>
                                <td>
                                  <span
                                    className='btn btn-primary pointer_class small-btn tooltip_wrap margin_right_20'
                                    onClick={() =>
                                      this.viewAttemptedExams(item)
                                    }
                                  >
                                    {language.LC().START}
                                  </span>
                                  <span className='privetinfo-dropdown'>
                                    <ButtonDropdown
                                      className={
                                        index + 1 === mockList2.length
                                          ? 'dropup'
                                          : ''
                                      }
                                      isOpen={
                                        dropdownOpenIndex === item.id
                                          ? dropdownOpen
                                          : false
                                      }
                                      toggle={() => this.toggle(item.id)}
                                    >
                                      <DropdownToggle
                                        className='btn btn-primary pointer_class small-btn tooltip_wrap margin_right_20'
                                        caret
                                      >
                                        {language.LC().PRINT}
                                      </DropdownToggle>
                                      <DropdownMenu right>
                                        <DropdownItem
                                          value='public'
                                          onClick={() => {
                                            this.checkSubscription(item, 'Q');
                                          }}
                                        >
                                          <i
                                            className='fa fa-print color-black'
                                            aria-hidden='true'
                                          />
                                          {language.LC().PRINT_Q_MOCK}
                                        </DropdownItem>
                                        <DropdownItem
                                          value='private'
                                          onClick={() => {
                                            this.checkSubscription(item, 'QA');
                                          }}
                                        >
                                          <i
                                            className='fa fa-print color-black'
                                            aria-hidden='true'
                                          />
                                          {language.LC().PRINT_QA_MOCK}
                                        </DropdownItem>
                                      </DropdownMenu>
                                    </ButtonDropdown>
                                  </span>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td
                              colSpan={'4'}
                              className={'text-center py-4 px-2'}
                            >
                              <div className='no-qus-found no-mock-exam'>
                                <img
                                  width='80px'
                                  src={
                                    App_data.frontend_url +
                                    '/img/questions/problem.png'
                                  }
                                />
                                <h3>{language.LC().No_Mock_Exams}</h3>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ModalComponent
          goPremium={this.goPremium.bind(this)}
          toggleAlert={this.toggleAlert.bind(this)}
          alert_status={this.state.alert_status}
          MessageContent={this.state.MessageContent}
        />
        <Modal
          isOpen={this.state.pdfMessageOpen}
          toggle={this.togglePdfMessage}
          className='modal-primary custom_modalpro info-modal-designing'
        >
          <ModalHeader toggle={this.togglePdfMessage} className='custom-title'>
            Information
          </ModalHeader>
          <ModalBody>
            <div className='modal-info-view-for-plan'>
              <p>{this.state.pdfMessage}</p>
              <div className='btn-plan-view view-plan-wrap'>
                <Button className='btn btn-primary' onClick={this.togglePdfMessage}>
                  OK
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <CBTMockExamsInsructions
          showInstructionModal={showInstructionModal}
          getQuestions={() => this.getQuestions(mockData)}
          handleClose={() => this.setState({ showInstructionModal: false })}
        />
      </div>
    );
  }
}

export default CBTMockExams;



// WEBPACK FOOTER //
// ./src/views/CBT/FRMCBT/MockList/index.js